<template>
  <div class="warp">
    <div class="enter_innovation_wrap">
      <div class="enter_img">
        <div class="img_tit hidden-xs-only">通知公告</div>
        <div class="img_tit hidden-sm-and-up">通知公告</div>
      </div>
    </div>
    <div class="tab">
      <div class="tab_item active" @click="toNews(1)">通知公告</div>
      <div class="tab_item" @click="toNews(2)">中心新闻</div>
      <div class="tab_item" @click="toNews(3)">行业资讯</div>
      <div class="tab_item" @click="toNews(4)">会议活动</div>
    </div>
    <div class="card_wrap">
      <div
        class="brain_item"
        v-for="(item, index) in cardList"
        :key="index"
        @click="handleNavigate(item.path)"
      >
        <div class="item_title">
          <img :src="item.img" alt="" />
        </div>
        <div class="item_desc">{{ item.desc }}</div>
        <div class="item_data">{{ item.data.slice(0, 60) + "..." }}</div>
        <div class="item_bg"></div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      cardList: [
        {
          img: require("@/assets/news1.png"),
          desc: "关于公司申报2024年度“江苏省科学技术奖”的公示",
          data: "根据《省科技厅关于2024年度江苏省科学技术奖提名工作的通知》(苏科资发〔2025〕90号)的相关要求，现由公司申报2024年度江苏省科学技术奖。项目名称：废旧聚酯瓶片熔体直纺高效低碳关键技术研发及高品质应用完成人：陈烨，孔文龙，柯福佑，刘水平，王健康，王志鹏，张慧颖，王华平，梅锋完成单位：江苏芮邦科技有限公司、东华大学、江苏佩浦高分子科技有限公司、江苏三联新材料股份有限公司、盐城工学院、江苏新视",
          path: "/news/news",
        },
        {
          img: "https://admin.naffic.cn/uploads/allimg/20250616/1-2506160UZ0228.jpg",
          title: "中心新闻",
          desc: "他让一根纤维连接地月：中国教育电视台“育见”对话创新中心主任王华平",
          data: "5月30日，在第九个全国科技工作者日到来之际，“育见新闻”播出“敢为”系列访谈节目第四期，对话东华大学材料学院研究员、教育部高性能纤维重点实验室主任、国家先进功能纤维创新中心主任王华平。该栏目以“高远立意、高端布局、高度关注”的理念，关注国计、关注民生，把握时代脉搏，解读政策动态，构筑教育政务服务新通道，搭建教育政策解析新平台。一根纤维如何改变世界？他给出了自己的解答。节目视频——王华平：举“纤",
          path: "/news/news",
        },
        {
          img: "https://admin.naffic.cn/uploads/allimg/20250702/1-250F20PPL29.jpg",
          title: "会议活动",
          desc: "『碳路先锋、绿动未来』2025气候创新·时尚大会",
          data: "『碳路先锋、绿动未来』2025气候创新·时尚大会平行会议“碳中和行动与时尚气候创新”在京举办6月25日全国低碳日，第四届“气候创新·时尚大会”在北京举行，强化纺织行业企业在低碳转型方面的引导与交流，提升纺织行业在应对气候变化、实现碳达峰与碳中和目标过程中的创新能力。会上发布了多项重要报告，包括中国纺织服装行业气候创新行动的进展与展望、中国纺织行业‘专精特新’企业气候行动研究报告、中国纺织业脱碳可再",
          path: "/news/news",
        },
        {
          img: require("@/assets/news1.png"),
          desc: "关于公司申报2024年度“江苏省科学技术奖”的公示",
          data: "根据《省科技厅关于2024年度江苏省科学技术奖提名工作的通知》(苏科资发〔2025〕90号)的相关要求，现由公司申报2024年度江苏省科学技术奖。项目名称：废旧聚酯瓶片熔体直纺高效低碳关键技术研发及高品质应用完成人：陈烨，孔文龙，柯福佑，刘水平，王健康，王志鹏，张慧颖，王华平，梅锋完成单位：江苏芮邦科技有限公司、东华大学、江苏佩浦高分子科技有限公司、江苏三联新材料股份有限公司、盐城工学院、江苏新视",
          path: "/news/news",
        },
        {
          img: "https://admin.naffic.cn/uploads/allimg/20250616/1-2506160UZ0228.jpg",
          title: "中心新闻",
          desc: "他让一根纤维连接地月：中国教育电视台“育见”对话创新中心主任王华平",
          data: "5月30日，在第九个全国科技工作者日到来之际，“育见新闻”播出“敢为”系列访谈节目第四期，对话东华大学材料学院研究员、教育部高性能纤维重点实验室主任、国家先进功能纤维创新中心主任王华平。该栏目以“高远立意、高端布局、高度关注”的理念，关注国计、关注民生，把握时代脉搏，解读政策动态，构筑教育政务服务新通道，搭建教育政策解析新平台。一根纤维如何改变世界？他给出了自己的解答。节目视频——王华平：举“纤",
          path: "/news/news",
        },
        {
          img: "https://admin.naffic.cn/uploads/allimg/20250702/1-250F20PPL29.jpg",
          title: "会议活动",
          desc: "『碳路先锋、绿动未来』2025气候创新·时尚大会",
          data: "『碳路先锋、绿动未来』2025气候创新·时尚大会平行会议“碳中和行动与时尚气候创新”在京举办6月25日全国低碳日，第四届“气候创新·时尚大会”在北京举行，强化纺织行业企业在低碳转型方面的引导与交流，提升纺织行业在应对气候变化、实现碳达峰与碳中和目标过程中的创新能力。会上发布了多项重要报告，包括中国纺织服装行业气候创新行动的进展与展望、中国纺织行业‘专精特新’企业气候行动研究报告、中国纺织业脱碳可再",
          path: "/news/news",
        },
        {
          img: require("@/assets/news1.png"),
          desc: "关于公司申报2024年度“江苏省科学技术奖”的公示",
          data: "根据《省科技厅关于2024年度江苏省科学技术奖提名工作的通知》(苏科资发〔2025〕90号)的相关要求，现由公司申报2024年度江苏省科学技术奖。项目名称：废旧聚酯瓶片熔体直纺高效低碳关键技术研发及高品质应用完成人：陈烨，孔文龙，柯福佑，刘水平，王健康，王志鹏，张慧颖，王华平，梅锋完成单位：江苏芮邦科技有限公司、东华大学、江苏佩浦高分子科技有限公司、江苏三联新材料股份有限公司、盐城工学院、江苏新视",
          path: "/news/news",
        },
        {
          img: "https://admin.naffic.cn/uploads/allimg/20250616/1-2506160UZ0228.jpg",
          title: "中心新闻",
          desc: "他让一根纤维连接地月：中国教育电视台“育见”对话创新中心主任王华平",
          data: "5月30日，在第九个全国科技工作者日到来之际，“育见新闻”播出“敢为”系列访谈节目第四期，对话东华大学材料学院研究员、教育部高性能纤维重点实验室主任、国家先进功能纤维创新中心主任王华平。该栏目以“高远立意、高端布局、高度关注”的理念，关注国计、关注民生，把握时代脉搏，解读政策动态，构筑教育政务服务新通道，搭建教育政策解析新平台。一根纤维如何改变世界？他给出了自己的解答。节目视频——王华平：举“纤",
          path: "/news/news",
        },
        {
          img: "https://admin.naffic.cn/uploads/allimg/20250702/1-250F20PPL29.jpg",
          title: "会议活动",
          desc: "『碳路先锋、绿动未来』2025气候创新·时尚大会",
          data: "『碳路先锋、绿动未来』2025气候创新·时尚大会平行会议“碳中和行动与时尚气候创新”在京举办6月25日全国低碳日，第四届“气候创新·时尚大会”在北京举行，强化纺织行业企业在低碳转型方面的引导与交流，提升纺织行业在应对气候变化、实现碳达峰与碳中和目标过程中的创新能力。会上发布了多项重要报告，包括中国纺织服装行业气候创新行动的进展与展望、中国纺织行业‘专精特新’企业气候行动研究报告、中国纺织业脱碳可再",
          path: "/news/news",
        },
      ],
    };
  },
  methods: {
    handleNavigate(path) {
      this.$router.push(path).catch((v) => {});
    },
    toNews(index) {
      this.$router.push(`/news/${index}`).catch((v) => {});
    },
  },
};
</script>

<style lang="scss" scoped>
.tab {
  color: #fff;
  height: 70px;
  display: flex;
  justify-content: center;
  margin-top: 20px;
  @media screen and (max-width: 768px) {
    height: 40px;
    margin-top: 20px;
  }
  .tab_item {
    line-height: 70px;
    margin-right: 30px;
    padding: 0 30px;
    cursor: pointer;
    font-size: 24px;
    transition: all 0.5s;
    background: #7f7f7f;
    @media screen and (max-width: 768px) {
      line-height: 40px;
      font-size: 10px;
      padding: 0 20px;
    }
    &:hover {
      transform: translateY(-8px);
    }
  }
  .active {
    background: #0f66ab;
  }
}
.enter_innovation_wrap {
  width: 100%;
  .enter_img {
    width: 100%;
    height: 600px;
    @media screen and (max-width: 768px) {
      height: 50vw;
    }
    background: url("../../assets/news.jpg") 0 0 no-repeat;
    background-size: 100% 100%;
    color: #fff;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    position: relative;
    .img_tit {
      font-size: 60px;
      font-weight: bold;
      @media screen and (max-width: 768px) {
        font-size: 1.2rem;
        text-align: center;
      }
    }
    .img_desc {
      font-size: 32px;
      margin-top: 20px;
      text-align: center;
      @media screen and (max-width: 768px) {
        font-size: 0.85rem;
      }
    }
  }
}
.card_wrap {
  width: 80%;
  display: flex;
  flex-wrap: wrap;
  margin: 0px auto;
  justify-content: space-between;
  @media screen and (max-width: 768px) {
    width: 90%;
    display: block;
  }
  .brain_item {
    width: 30%;
    transition: background-color 1s;
    padding: 30px;
    cursor: pointer;
    background: #fff;
    border-radius: 20px;
    box-shadow: 0 0.5rem 1.5rem 0 rgba(0, 135, 168, 0.15);
    margin-top: 50px;
    position: relative;
    @media screen and (max-width: 768px) {
      width: 100%;
      font-size: 0.8rem;
      border-radius: 10px;
      display: flex;
      flex-wrap: wrap;
      justify-content: center;
      margin-top: 40px;
    }
    .item_bg {
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      background: linear-gradient(134deg, #0649b8 1%, #0a7fd7 41%, #03d2c5 99%);
      opacity: 0;
      transition: all 0.5s;
      border-radius: 20px;
      z-index: 1;
    }
    &:hover .item_bg {
      opacity: 1;
    }
    // &:hover .item_title {
    // }
    &:hover .item_desc {
      color: #fff;
    }
    &:hover .item_data {
      color: #fff;
    }
    .item_title {
      position: inherit;
      transition: all 0.5s;
      padding: 20px 0 40px 0;
      z-index: 2;
      @media screen and (max-width: 768px) {
        width: 100%;
      }
      img {
        width: 100%;
        height: 150px;
        object-fit: cover;
      }
      @media screen and (max-width: 768px) {
        font-size: 1rem;
        text-align: center;
        img {
          width: 100%;
          height: 150px;
          object-fit: cover;
        }
      }
    }
    .item_desc {
      transition: all 0.5s;
      color: #666;
      text-align: left;
      line-height: 1.5rem;
      z-index: 2;
      position: inherit;
      font-size: 18px;
      margin-bottom: 10px;
      @media screen and (max-width: 768px) {
        text-indent: 2em;
        font-size: 12px;
      }
    }
    .item_data {
      transition: all 0.5s;
      color: #666;
      text-align: left;
      line-height: 1.5rem;
      z-index: 2;
      position: inherit;
      font-size: 14px;
      @media screen and (max-width: 768px) {
        text-indent: 2em;
        font-size: 9px;
      }
    }
    .item_navigate {
      width: 100px;
      height: 30px;
      padding: 0 10px;
      background: #ffa400;
      color: #fff;
      border-radius: 20px;
      display: flex;
      justify-content: center;
      align-items: center;
      font-size: 14px;
      margin-top: 20px;
      cursor: pointer;
      z-index: 2;
      position: inherit;
      @media screen and (max-width: 768px) {
        width: 60px;
        height: 20px;
        margin-bottom: 10px;
        font-size: 9px;
      }
    }
  }
}
</style>